import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { LanguageToggle } from '../components/ui';
import { IconLayers, IconLink, IconLock, IconOrbit } from '../components/icons';
import { t } from '../i18n';

/** Built per render so the feature cards follow the chosen language. */
function features() {
  return [
    { icon: IconLink, title: t('landing.foundTitle'), body: t('landing.foundBody') },
    { icon: IconLayers, title: t('landing.storyTitle'), body: t('landing.storyBody') },
    { icon: IconLock, title: t('landing.privateTitle'), body: t('landing.privateBody') },
  ];
}

export function LandingPage() {
  const { user } = useAuth();
  return (
    <div className="page landing">
      <header className="landing-nav">
        <Link className="brand" to="/">
          <span className="brand__mark"><IconOrbit size={26} /></span>
          my-lib<span className="brand__space">space</span>
        </Link>
        <div className="row" style={{ gap: 'var(--sp-3)' }}>
          <LanguageToggle />
          <Link className="btn btn--outline btn--sm" to={user ? '/app' : '/login'}>
            {user ? t('nav.toLibrary') : t('nav.enter')}
          </Link>
        </div>
      </header>
      <main>
        <section className="hero">
          <div className="hero__copy">
            <span className="hero__eyebrow"><span className="dot" aria-hidden="true" /> {t('landing.eyebrow')}</span>
            <h1 className="hero__title">
              {t('landing.heroTitle1')}
              <br />
              {t('landing.heroTitle2')}
              <br />
              <em>{t('landing.heroTitle3')}</em>
            </h1>
            <p className="hero__lede">{t('landing.heroLede')}</p>
            <div className="hero__actions">
              <Link className="btn btn--primary btn--lg" to={user ? '/app/library' : '/register'}>
                {user ? t('landing.openLibrary') : t('landing.createLibrary')} <span aria-hidden="true">↗</span>
              </Link>
              <span className="hero__note">{t('landing.heroNote')}</span>
            </div>
          </div>
          <figure className="collection-preview" aria-label={t('landing.previewAlt')}>
            <div className="collection-preview__card collection-preview__card--note">
              <span>{t('landing.demoCollection')}</span>
              <strong>
                {t('landing.demoCollectionTitle1')}
                <br />
                {t('landing.demoCollectionTitle2')}
              </strong>
              <span>{t('landing.demoCollectionSub')}</span>
            </div>
            <div className="collection-preview__card collection-preview__card--book">
              <span>{t('landing.demoBookKind')}</span>
              <strong>{t('landing.demoBookTitle')}</strong>
              <span>{t('landing.demoBookSub')}</span>
            </div>
            <div className="collection-preview__card collection-preview__card--movie">
              <span>{t('landing.demoFilmKind')}</span>
              <strong>
                {t('landing.demoFilmTitle1')}
                <br />
                {t('landing.demoFilmTitle2')}
              </strong>
              <span>{t('landing.demoFilmAuthor')}</span>
            </div>
            <figcaption className="collection-preview__label">{t('landing.demoCaption')}</figcaption>
          </figure>
        </section>
        <section className="landing-how" aria-labelledby="how">
          <div className="landing-how__head">
            <span className="caps">{t('landing.howCaps')}</span>
            <h2 id="how">{t('landing.howTitle')}</h2>
          </div>
          <div className="feature-grid">
            {features().map(feature => (
              <article className="feature" key={feature.title}>
                <span className="feature__icon"><feature.icon size={21} /></span>
                <h3>{feature.title}</h3><p>{feature.body}</p>
              </article>
            ))}
          </div>
        </section>
      </main>
      <footer className="landing-footer"><span>my-lib.space</span><span>{t('landing.footer')}</span></footer>
    </div>
  );
}
